import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=47be848e&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=47be848e&prod&lang=scss"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=47be848e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be848e",
  null
  
)

export default component.exports